
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { ExternalLink } from "lucide-react";
import { WorksheetTableActions } from "./WorksheetTableActions";
import { Worksheet } from "@/hooks/worksheet/useWorksheetAPI";

interface WorksheetTableRowProps {
  worksheet: Worksheet;
  onEditClick: (worksheet: Worksheet) => void;
  onDeleteClick: (id: number) => void;
  formatDate: (dateString: string) => string;
}

export const WorksheetTableRow: React.FC<WorksheetTableRowProps> = ({
  worksheet,
  onEditClick,
  onDeleteClick,
  formatDate
}) => {
  return (
    <TableRow>
      <TableCell className="font-medium">{worksheet.id}</TableCell>
      <TableCell>{worksheet.name}</TableCell>
      <TableCell>{worksheet.subject}</TableCell>
      <TableCell>{worksheet.grade_level}</TableCell>
      <TableCell>{worksheet.semester || '-'}</TableCell>
      <TableCell>
        {worksheet.document_urls && worksheet.document_urls.length > 0 ? (
          <div className="flex items-center space-x-2">
            <span className="text-green-600">{worksheet.document_urls.length} ไฟล์</span>
            <a 
              href={worksheet.document_urls[0]} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-blue-700"
            >
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        ) : (
          <span className="text-gray-400">ไม่มีไฟล์</span>
        )}
      </TableCell>
      <TableCell>{worksheet.created_at ? formatDate(worksheet.created_at) : '-'}</TableCell>
      <TableCell>
        <WorksheetTableActions 
          worksheet={worksheet}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
        />
      </TableCell>
    </TableRow>
  );
};
